import { CodeTypeId, MileageLossCode } from '@/types/logs'

export const getCodeTypeId = (code?: string): CodeTypeId | undefined =>
    code ? (code in MileageLossCode ? 'ML' : 'DL') : undefined
